import React from 'react';

/**
 * False while rendering on the server and for the browser's first render, true from the
 * moment after hydration.
 *
 * Gate anything that cannot exist on the server on this - WebGL previews, measured layout,
 * anything reading the DOM. Checking `typeof window` instead would make the browser's first
 * render disagree with the server's markup, which is exactly what hydration cannot tolerate;
 * flipping in an effect keeps both sides identical and adds the extra afterwards.
 */
export function useIsHydrated(): boolean {
    const [isHydrated, setIsHydrated] = React.useState(false);

    React.useEffect(() => {
        setIsHydrated(true);
    }, []);

    return isHydrated;
}
